import { getMenuIcon } from '@app/utils/menu/getMenuIcon'

import type { MenuItem } from '@app/types/menu'
import type { RawMenuItem } from '@app/types/menu/raw'

export const getMenuItem = ({ key, label, disabled, icon, iconProps }: RawMenuItem): MenuItem => ({
  key,
  label,
  disabled,
  icon: icon ?? getMenuIcon(iconProps)
})
